const $                   = require('jquery');
const _                   = require('underscore');
const qs                  = require('query-string');
const queue               = require('async/queue');
const { detect }          = require('detect-browser');
const { icon }            = require('@fortawesome/fontawesome-svg-core');
const endpoint            = require('@readcube/endpoint');
const pkg                 = require('@readcube/pkg').default;
const deps                = require('../deps');
const user                = require('../user');
const tpl                 = require('../util/template');
const online              = require('../ctrl/online');
const guid                = require('../util/guid');
const chunkArray          = require('../util/chunk_array');
const evtout              = require('../evtout');
const platform            = require('../platform');

const CHUNK_SIZE = 10;
const browser = detect();

const statusQ = queue((task, cb) => task().then(cb));

const faIconOpts = { classes: ['fa-icon icon-h-14'] };
const fa = {
  user: require('@fortawesome/pro-solid-svg-icons/faUser').definition,
  fileSearch: require('@fortawesome/pro-light-svg-icons/faFileSearch').definition
};

function reference({ references, syncApi }) {
  references = _.uniq(references, false, ref => ref.doi || guid());
  const elem = $(`
    <div class="reference-list">
      ${references.map((ref, idx) => {
        return `
          <div ref-idx="${idx}"
            class="reference-item ${tpl.cls({ reference: ref.badge })}"
            ${tpl.if(ref.doi, () => `data-doi="${ref.doi}"`)}">
            ${tpl.if(ref.badge, () => badge(ref))}
            ${tpl.if(ref.title, () => title(ref))}
            ${tpl.if(ref.authors && ref.authors.length, () => authors(ref))}
            <div class="published">${published(ref)}</div>
            <div class="buttons">
              ${tpl.if(!ref.doi && ref.find_article_url, () => search(ref))}
              ${tpl.if(ref.doi, () => buttons(ref))}
            </div>
          </div>`;
      }).join('')}
    </div>
  `);

  const dois = references.filter(r => !!r.doi).map(r => r.doi);
  const set  = new Set(dois);

  online.wait(() => {
    syncApi.user.extension().then(userData => {
      renderButtons({ elem, dois, userData });
    });
  });

  elem.on('click', '.linkout', e => {
    const idx = $(e.target).closest('.reference-item[ref-idx]').attr('ref-idx');
    const ref = references[parseInt(idx)];
    const url = ref.article_url || ref.find_article_url;
    evtout.trigger('open-url', [url, true]);
  });

  elem.on('click', '.library-button', e => {
    const libBtn = $(e.target).closest('.library-button');
    const doi = libBtn.attr('data-doi');

    if (libBtn.hasClass('in-library')) {
      // _.omit(e.originalEvent, 'type')
      // TODO: use $.Event('open-in-library', e) for desktop
      evtout.trigger('open-in-library', [libBtn.data('sync-item')]);
    } else {
      online.guard(() => addToLibrary({ elem, doi }))();
    }
  });

  return elem;

  function addToLibrary({ elem, doi }) {
    const libBtn = elem.find(`.library-button[data-doi="${doi}"]`);

    libBtn.addClass('importing');

    const collectionId = user.data.id;
    const extIds = { doi };
    const resolveFiles = true;
    const skipResolveFiles = !resolveFiles;

    syncApi.items.create({ collectionId, extIds, resolveFiles, skipResolveFiles })
      .then(result => {
        result.item.has_file = !!result.item?.files?.length;

        libBtn.data('sync-item', result.item)
        libBtn.addClass('in-library');
        libBtn.toggleClass('has-file', result.item.has_file);

        forcePaint(libBtn);

        const pdfButtons = elem.data('pdf-buttons') || {};
        const pdfBtn = pdfButtons[doi];
        if (pdfBtn) {
          institutionStatus({ dois: [doi], skipCache: true }).then(statuses => {
            pdfBtn.update({ institutionStatus: statuses[doi] });
          });
        }
      })
      .catch(() => {})
      .finally(() => libBtn.removeClass('importing'));
  }

  function renderButtons({ elem, dois, userData }) {
    chunkArray(dois, CHUNK_SIZE).forEach(chunk => {
      institutionStatus({ dois: chunk }).then(statuses => {
        pkg.load('@readcube/pdf-button', deps['@readcube/pdf-button'])
          .then(({ PdfButton }) => {
            renderViewPdf({ elem, dois: chunk, statuses, userData, PdfButton });
          }).catch(e => {
            chunk.forEach(doi => elem.find(`.pdf-button[data-doi="${doi}"]`).hide());
          });
        renderLibrary({ elem, dois: chunk, statuses, userData });
        renderShare({ elem, dois: chunk, statuses });
      });
    });
  }

  function renderViewPdf({ elem, dois, statuses, userData, PdfButton }) {
    const pdfButtons = elem.data('pdf-buttons') || {};

    function openReader({ doi, status_token }) {
      const url = status_token ?
        `${endpoint.web}/articles/${doi}?${qs.stringify({ status_token })}` :
        `${endpoint.web}/articles/${doi}`;

      evtout.trigger('open-url', [url, true]);
    }

    dois.forEach(doi => {
      if (pdfButtons[doi]) {
        pdfButtons[doi].update({ institutionStatus: statuses[doi], user: userData });
        return;
      }

      const button = elem.find(`.pdf-button[data-doi="${doi}"]`).show();
      const pdfBtn = pdfButtons[doi] = new PdfButton({
        doi, institutionStatus: statuses[doi],
        element: button[0], user: userData
      });

      pdfBtn.on('readPdf', ({ doi, status_token }) => {
        online.guard(() => openReader({ doi, status_token }))();
      });

      pdfBtn.on('showDocDelPreview', ({ doi }) => {
        online.guard(() => openReader({ doi }))();
      });

      pdfBtn.on('readOpenAccessPdf', ({ doi, status_token, hosted, url }) => {
        online.guard(() => {
          hosted ?
            openReader({ doi, status_token }) :
            evtout.trigger('open-url', [url, true]);
        })();
      });

      pdfBtn.on('readPersonalPdf', ({ collection_id, item_id }) => {
        evtout.trigger('read-in-library', [{ collection_id, id: item_id }]);
      });

      pdfBtn.on('openPdfUrl', ({ url }) => {
        online.guard(() => evtout.trigger('open-url', [url, true]))();
      });

      pdfBtn.on('openRetractedArticle', ({ doi }) => {
        const url = `https://doi.org/${doi}`;
        online.guard(() => evtout.trigger('open-url', [url, true]))();
      });
    });

    elem.data('pdf-buttons', pdfButtons);
  }

  function renderLibrary({ elem, dois, statuses, userData }) {
    dois.forEach(doi => {
      const libBtn = elem.find(`.library-button[data-doi="${doi}"]`);
      const result = Object.assign({ items: [] }, statuses[doi]);
      const synced = result.items.length > 0;
      const pdfItem = result.items.find(item => item.has_file);

      if (!!synced != libBtn.hasClass('in-library') ||
          !!pdfItem != libBtn.hasClass('has-file')) {
        libBtn.toggleClass('in-library', !!synced);
        libBtn.toggleClass('has-file', !!pdfItem);
        forcePaint(libBtn);
      }

      if (synced) {
        libBtn.data('sync-item', pdfItem || result.items[0]);
      }
    });
  }

  function renderShare({ elem, dois, statuses }) {
    if (platform.app) return;

    dois.forEach(doi => {
      if (isShareable(statuses[doi])) {
        elem.find(`.share-button[data-doi="${doi}"]`).show();
      }
    });
  }

  function isShareable(status) {
    if (status.open_access && status.load_in_viewer) return true;
    return status.access_programs &&
      status.access_programs.length &&
      status.access_programs.indexOf('covid-19') != -1;
  }

  function institutionStatus({ dois, skipCache }) {
    return new Promise((resolve, reject) => {
      online.wait(() => {
        let cache = institutionStatus.cache;
        if (!cache) {
          cache = institutionStatus.cache = {};
        }

        const missed = dois.filter(doi => skipCache || !cache[doi]);
        if (!missed.length) {
          return resolve(_.pick(cache, dois));
        }

        statusQ.push(() => {
          return syncApi.institution.status({ dois: missed }).then(data => {
            Object.keys(data).forEach(doi => {
              cache[doi] = data[doi];
            });
            resolve(_.pick(cache, dois));
          }).catch(reject);
        });
      });
    });
  }
}

function forcePaint(elem) {
  if (browser.name == 'safari' && elem[0]) {
    requestAnimationFrame(() => {
      elem.style.display = 'none';
      elem.offsetHeight;
      elem.style.display = display;
    });
  }
}

function linkify(text) {
  // strip brackets from urls
  text = text.replace(/<(http[^>]+)>/g, function(match, url) { return url; });
  // insert links for urls
  return text.replace(
    /(http|ftp|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/g,
    match => `<a href="${match}" target="_blank"> ${match} </a>`
  );
}

function badge(ref) {
  return `<div class="number">${ref.badge}</div>`;
}

function title(ref) {
  return `
    <h4 class="title">
      ${tpl.if(!ref.doi, () => linkify(ref.title))}
      ${tpl.if(ref.doi, () => `<a class="linkout">${ref.title}</a>`)}
    </h4>`;
}

function authors(ref) {
  return `<div class="authors">${ref.authors.slice(0, 10).join(', ')}</div>`
}

function published(ref) {
  if (ref.journal && ref.year) {
    return ref.journal + ', ' + ref.year;
  } else {
    return ref.journal || ref.year || '';
  }
}

function search(ref) {
  return `
    <button class="find-article linkout">
      ${icon(fa.fileSearch, faIconOpts).html}
      <span>Find Article</span>
    </button>
  `;
}

function buttons(ref) {
  return `
    <span class="pdf-button" data-doi="${ref.doi}">
      <span class="readcube-skeleton-line"></span>
    </span>
    <button class="library-button" data-doi="${ref.doi}">
      <span class="add-text">Add to Library</span>
      <span class="busy-text">Importing...</span>
      <span class="added-text">In Library</span>
    </button>
  `;

  // DISABLED
  `
    <button class="share-button" data-doi="${ref.doi}">
      <span>Share</span>
    </button>
  `;
}

module.exports = reference;
